import classes from './Element.module.css'
import FactorPinViewer from './FactorPinViewer'

function ProcessViewer (props) {

    function getTextWidth(text, font) {
        // Create a canvas element
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        
        // Set the font for the context
        context.font = font;
        
        // Measure the width of the text
        const width = context.measureText(text).width;
        
        // Return the width
        return width;
    }
    
    let num_pins = props.max_num_pins;
    let height_pin_full = 35;
    let minHeight = 170;
    let height_process = (num_pins+1.25)*height_pin_full;
    height_process =height_process.toString() + 'px';
    minHeight = minHeight.toString() + 'px';


    let all_factors = (<></>);
    if (props.element.pins) {
        let max_length_pinname = Math.max(props.element.pins.reduce((max, pin) => Math.max(max, getTextWidth(pin.name, '14px Roboto')), 0), 60) ;
        all_factors = props.element.pins.map((pin, pinIndex) => (
            <FactorPinViewer key={props.elem_id+'_'+pinIndex} 
                       id={props.elem_id+'_'+pinIndex} 
                       name={pin.name}
                       max_length_pinname={max_length_pinname}/>
        ));
   
    }


    return (
        <>
            <div id='outer container' className={classes.outer_container}>
                <div id='factor container' className={classes.pin_container} style = {{height: height_process, minHeight: minHeight}}>
                    {all_factors}
                </div>
                <div id='process container out' className={classes.color_block_container} >
                    <div id='process container' className={classes.upper_container} style ={{height: height_process, minHeight: minHeight}}>
                        <div id='action_panel' className={classes.action_panel} >
                        </div>
                        <div id='main container' className={classes.upper_container_main} >
                            <div style={{height: '30px'}}></div>
                            <p className={classes.textareaviewer} >
                                {props.element.name}
                            </p>
                        </div>
                    </div>
                    <div className={classes.block_name} >Process</div>
                    <div id='footer_container' className={classes.footer_container} >
                    </div>
                </div>
            </div>
        </>);
}    

export default ProcessViewer